<template>
  <reg-card>
    <div class="card-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ff825d" stroke-width="2">
        <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
      </svg>
    </div>
    <h2 class="title">Qual o seu sistema POS?</h2>
    <p class="sub">Isso permite-nos configurar as integrações correctas para o seu negócio.</p>

    <div class="pos-list">
      <button
        v-for="opt in opcoes" :key="opt.value"
        class="pos-btn"
        :class="{ selected: selecionado === opt.value }"
        @click="selecionado = opt.value"
      >
        <div class="pos-icon">
          <component :is="opt.icon" />
        </div>
        <div class="pos-info">
          <span class="pos-nome">{{ opt.label }}</span>
          <span class="pos-desc">{{ opt.desc }}</span>
        </div>
        <div class="pos-check" :class="{ on: selecionado === opt.value }">
          <svg v-if="selecionado === opt.value" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3.5"><path d="M20 6 9 17l-5-5"/></svg>
        </div>
      </button>
    </div>

    <button class="btn-dark" :disabled="!selecionado" @click="$emit('done', selecionado)">
      AVANÇAR
    </button>
  </reg-card>
</template>

<script>
import RegCard from "../components/RegCard.vue";

const IconZonesoft = { template: `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M8 12h8M12 8v8"/></svg>` };
const IconWinrest  = { template: `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>` };
const IconCustom   = { template: `<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="3"/><path d="M19.07 4.93A10 10 0 1 1 4.93 19.07 10 10 0 0 1 19.07 4.93"/></svg>` };

export default {
  name: "OStep0",
  components: { RegCard },
  props: { value: { default: null } },
  data() {
    return {
      selecionado: this.value,
      opcoes: [
        { value: "zonesoft", label: "Zonesoft", desc: "Sistema de gestão Zonesoft", icon: "IconZonesoft" },
        { value: "winrest",  label: "Winrest",  desc: "Sistema de gestão Winrest",  icon: "IconWinrest"  },
        { value: "custom",   label: "Outro / Nenhum", desc: "Outro sistema ou sem integração", icon: "IconCustom" },
      ],
    };
  },
  components: { RegCard, IconZonesoft, IconWinrest, IconCustom },
};
</script>

<style scoped lang="scss">
.card-icon { width: 40px; height: 40px; background: #fff5f0; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-bottom: 14px; }
.title     { font-size: 22px; font-weight: 800; color: #1a1210; margin-bottom: 6px; }
.sub       { font-size: 13.5px; color: #7a736e; margin-bottom: 20px; line-height: 1.5; }

.pos-list  { display: flex; flex-direction: column; gap: 10px; margin-bottom: 20px; }
.pos-btn   {
  display: flex; align-items: center; gap: 14px;
  padding: 14px 16px; border: 1.5px solid #e8e4e0; border-radius: 12px;
  background: #fff; cursor: pointer; font-family: inherit; transition: all .15s; text-align: left;
  &:hover { border-color: #ff825d; background: rgba(255,130,93,.02); }
  &.selected { border-color: #ff825d; background: rgba(255,130,93,.04); }
}
.pos-icon  { width: 40px; height: 40px; background: #f7f4f1; border-radius: 10px; display: flex; align-items: center; justify-content: center; color: #7a736e; flex-shrink: 0; .pos-btn.selected & { background: #fff0eb; color: #ff825d; } }
.pos-info  { flex: 1; display: flex; flex-direction: column; }
.pos-nome  { font-size: 14px; font-weight: 700; color: #1a1210; }
.pos-desc  { font-size: 12px; color: #b0a8a0; margin-top: 2px; }
.pos-check { width: 22px; height: 22px; border-radius: 50%; border: 1.5px solid #e8e4e0; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: all .15s; &.on { background: #ff825d; border-color: #ff825d; } }

.btn-dark { display: flex; align-items: center; justify-content: center; width: 100%; height: 50px; border: none; border-radius: 10px; background: #1a1210; color: #fff; font-size: 14px; font-weight: 700; cursor: pointer; font-family: inherit; &:hover:not(:disabled) { background: #2d2420; } &:disabled { opacity: .45; cursor: default; } }
</style>
